export const utils = {
  roundToN: (num, decimals) => {
    return Math.round((num + Number.EPSILON) * 10 ** decimals) / 10 ** decimals;
  },
};
